var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"v-full-screen-songs-player"},[_c('div',{ref:"wrap",staticClass:"player-box"},[_c('div',{staticClass:"player-box-left"},[_c('lyrics',{ref:"lyrics"}),_c('controls',{ref:"controls"})],1),_c('div',{staticClass:"player-box-right"},[_c('poster'),_c('list',{ref:"lists"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }